import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Firebase configuration - same as main Cannalytix app
const firebaseConfig = {
  apiKey: "AIzaSyDHCZV6W7RmDfgYxP1PN63pf7xtD4qkG94",
  authDomain: "link-tracker-26f00.firebaseapp.com",
  projectId: "link-tracker-26f00",
  storageBucket: "link-tracker-26f00.firebasestorage.app",
  messagingSenderId: "107013313043",
  appId: "1:107013313043:web:03bd59885273304a0025e6",
  measurementId: "G-53T7978V6L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;

